import { connect, Component } from 'macguffin'
import BackgroundImage from "utils/BackgroundImage"

const spinsLeftStyle = {
    backgroundPosition: "top center"
}

const BOX_SCALE = 0.95
const TITLE_FONT_SCALE = 0.085
const SPINS_LEFT_FONT_SCALE = 0.25
const EXTRA_SPINS_FONT_SCALE = 0.18

@connect(state => ({
    currentGameMode: state.game.currentGameMode,
    currentFreespins: state.game.currentFreespins,
    extraFreespins: state.game.extraFreespins,
    currentPickStageIndex: state.game.currentPickStageIndex
}), {})

export default class FreespinsLeft extends Component {

    render() {
        const { props } = this
        const { currentGameMode, currentPickStageIndex, currentFreespins, extraFreespins, width, height, left } = props

        const showFreespins = currentGameMode === 'FREESPIN' || currentPickStageIndex > 0
        const opacity = extraFreespins ? 1 : 0

        if (!showFreespins) {
            return (<div />)
        }

        const sizeStyle = {
            width: `${width * BOX_SCALE}px`,
            height: `${width * BOX_SCALE}px`,
            top: `${width * BOX_SCALE * 0.5}px`,
        }

        const titleStyle = {
            color: "#ffffff",
            fontSize: `${width * TITLE_FONT_SCALE}px`
        }

        const spinsLeftTextStyle = {
            color: "#ffffff",
            fontSize: `${width * SPINS_LEFT_FONT_SCALE}px`
        }

        const extraSpinsTextStyle = {
            color: "#f5fa6c",
            fontSize: `${width * EXTRA_SPINS_FONT_SCALE}px`,
            opacity
        }

        const rightStyle = {
            "margin-right": left
        }

        return <div id="rightContent" key="rightContent" style={{...rightStyle}}>
            <BackgroundImage className="freeSpinsLeftContainer" assetName="freespinCounterBackground" style={{...spinsLeftStyle, ...sizeStyle}}>
                <h1 style={titleStyle}>{ this.t('freespins.freespinsRemaining')}</h1>
                <h1 style={spinsLeftTextStyle}> {currentFreespins} </h1>
                { !!extraFreespins && <h1 style={extraSpinsTextStyle}>{`+${extraFreespins}`} </h1> }
            </BackgroundImage>   
        </div>
        
    }

}
